import request from '@/utils/request'


export function QueryProduct (data) {
  return request({
    url: '/api/Product/QueryProduct',
    method: 'post',
    data
  })
}

export function GetInstallationVideo (params) {
  return request({
    url: '/api/Product/GetInstallationVideo',
    method: 'get',
    params
  })
}

export function GetProductPhotoList (productNo) {
  return request({
    url: '/api/Product/GetProductPhotoList?productNo=' + productNo,
    method: 'get'
  })
}

export function GetInstructions (productNo) {
  return request({
    url: '/api/Product/GetInstructions?productNo=' + productNo,
    method: 'get'
  })
}

export function GetPackingList (productNo) {
  return request({
    url: '/api/Product/GetPackingList?productNo=' + productNo,
    method: 'get'
  })
}

export function GetProductPartsList (productNo) {
  return request({
    url: '/api/Product/GetProductPartsList?productNo=' + productNo,
    method: 'get'
  })
}

export function GetProductFAQList (productNo) {
  return request({
    url: '/api/Product/GetProductFAQList?productNo=' + productNo,
    method: 'get'
  })
}

export function GetProductTagOptions () {
  return request({
    url: '/api/Product/GetProductTagOptions',
    method: 'get'
  })
}


export function GetProductTags (data) {
  return request({
    url: '/api/Product/GetProductTags',
    method: 'post',
    data
  })
}
